import React from "react";
import { QuestionMarkIcon, ThickChkIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";

const View = ({ selectUser, authorityList }) => {
	const { t, i18n } = useTranslation();

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	return (
		<div className="c__card role-table-card">
			<div className="role-table">
				<div className="thead">
					<div className="th selected-member">
						<div className="member-img">
							<img
								src={
									selectUser.img
										? selectUser.img
										: theme === "dark"
										? DarkDefaultProfileImg
										: LightDefaultProfileImg
								}
								alt={selectUser.name}
							/>
							{/*<img*/}
							{/*	src={selectUser.img ? selectUser.img : lightProfileImg}*/}
							{/*	alt={selectUser.name}*/}
							{/*/>*/}
						</div>
						<dl className="member-info">
							<dt>
								{selectUser.name} {selectUser.position}
							</dt>
							<dd>{selectUser.id}</dd>
						</dl>
					</div>
					<div className="th chk-area">
						<div className="auth-type">
							<p>{t("pages.myPage.admin.AuthPage.auth-type-p1")}</p>
							<div className="c__tooltip-btn">
								<QuestionMarkIcon />
								<span className="c__tooltip">
									{t("pages.myPage.admin.AuthPage.c__tooltip1")}
								</span>
							</div>
						</div>
					</div>
					<div className="th chk-area">
						<div className="auth-type">
							<p>{t("pages.myPage.admin.AuthPage.auth-type-p2")}</p>
							<div className="c__tooltip-btn">
								<QuestionMarkIcon />
								<span className="c__tooltip">
									{t("pages.myPage.admin.AuthPage.c__tooltip2")}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="tbody">
					{authorityList.map((menu, menu_idx) => {
						return (
							<div className="tr" key={menu_idx}>
								<div className="td role-colgroup-title">
									{i18n.language === "ko" ? menu.title : menu.id}
								</div>
								<div className="role-colgroup-wrap">
									{menu.subMenu.map((sub, s_idx) => {
										return (
											<div className="role-colgroup" key={s_idx}>
												<div className="role-info">
													<p className="td page-name">
														{i18n.language === "ko"
															? sub.title
															: sub.engTitle}
													</p>
													<p className="td page-desc">{sub.desc}</p>
												</div>
												<div
													className={`td chk-area ${
														sub.viewAuth ? "active" : ""
													}`}
												>
													<ThickChkIcon />
												</div>
												<div
													className={`td chk-area ${
														sub.editAuth ? "active" : ""
													}`}
												>
													<ThickChkIcon />
												</div>
											</div>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};
export default View;
